import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { FaHome, FaList, FaCalendarAlt, FaChevronDown, FaChevronRight } from 'react-icons/fa';

const Sidebar = ({ isOpen, onToggle }) => {
  const location = useLocation();
  const [isProgramasOpen, setIsProgramasOpen] = useState(false);

  const toggleProgramas = (e) => {
    e.preventDefault();
    setIsProgramasOpen(!isProgramasOpen);
  };

  return (
    <div className={`sidebar-container ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar">
        <button className="toggle-btn" onClick={onToggle}>
          {isOpen ? '×' : '☰'}
        </button>
        <div className="sidebar-content">
        <nav className="sidebar-nav">
          <Link 
            to="/home" 
            className={`nav-item ${location.pathname === '/home' ? 'active' : ''}`}
          >
            <FaHome className="nav-icon" />
            {isOpen && <span>Inicio</span>}
          </Link>
          
          <Link 
            to="/turnos-asignados" 
            className={`nav-item ${location.pathname === '/turnos-asignados' ? 'active' : ''}`}
          >
            <FaCalendarAlt className="nav-icon" />
            {isOpen && <span>Turnos</span>}
          </Link>
          
          <div className="nav-item-container">
            <div 
              className={`nav-item ${location.pathname.startsWith('/programas') ? 'active' : ''}`}
              onClick={toggleProgramas}
              style={{ cursor: 'pointer' }}
            >
              <FaList className="nav-icon" />
              {isOpen && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span>Programas</span>
                  {isProgramasOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
                </div>
              )}
            </div>
            {isOpen && isProgramasOpen && (
              <div className="submenu">
                <Link 
                  to="/dashboard" 
                  className={`nav-item submenu-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
                >
                  <span style={{ marginLeft: '24px' }}>Programa Cardiometabólico</span>
                </Link>
              </div>
            )}
          </div>
        </nav>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
